export default "__VITE_ASSET__DHOtD6Cs__"